import DefaultFormInput from "../../default_form_input";
import { FormSwitchInput } from "../../masked_inputs/react_forms/form_switch_input";
import { BaseDrawer, BaseDrawerState, CreateBaseDrawerHook } from "../base_drawer";

import z from "zod";

/**
 * Schema
 */

const MotivoDemissaoSchema = z.object({
  ativo: z.coerce.number(),
  descricaoMotivo: z.string(),
});

type MotivoDemissaoForm = z.infer<typeof MotivoDemissaoSchema>;

const defaultMotivoDemissaoForm: MotivoDemissaoForm = {
  ativo: 1,
  descricaoMotivo: '',
}

/**
 * useMotivoDemissaoDrawer
 * [motivoDemissaoStateDrawer, startMotivoDemissaoDrawer]
 */

export const useMotivoDemissaoDrawer = CreateBaseDrawerHook<MotivoDemissaoForm>();

/**
 * MotivoDemissaoDrawer
 */

type Props = {
  saving: boolean;
  state: BaseDrawerState<MotivoDemissaoForm>;
};

export const MotivoDemissaoDrawer = ({
  saving,
  state,
}: Props) => {
  return (
    <BaseDrawer
      title='Novo Motivo Demissão'
      schema={MotivoDemissaoSchema}
      state={state}
      saving={saving}
      defaultValues={defaultMotivoDemissaoForm}>
      {
        (hookForm) => (
          <>
            <FormSwitchInput
              name='ativo'
              readOnly={saving}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='descricaoMotivo'
              label='Motivo Demissão'
              readOnly={saving}
              required={true}
              multiline={true}
              rows={3}
              reactHookForm={hookForm}
            />
          </>
        )
      }
    </BaseDrawer>
  );
}